export enum StepIngressarAtendEnum {
  FilaPaVirtual = 1,
  StartIngressarAtend = 2,
  ValidarBiometriaFacial = 3,
  RedirectZoom = 4,
  AguardarFinalizacaoAtendimento = 5,
  ConfirmarFinalizacaoAtendimento = 6,
}